module.exports = __webpack_public_path__ + "static/media/logo.3fd11f69.png";